var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m3.90993907 2.6384872 16.50643753 17.0423678c.5190947.3909745.8744746 1.0000874.9347991 1.698049l.0091143.2119246-.0016129.0286107-.0032256.0654259c-.0037164.0908108-.0122012.1798686-.0250335.2678746-.0644422.4949367-.2727048.9745164-.6413366 1.3550805-.5089588.5249754-1.1975114.7513144-1.8611392.6790696l-.1981361-.0306309h-16.14103133c-1.2650935 0-2.29048879-1.0586654-2.29048879-2.3648694 0-1.243937.93006369-2.2634764 2.11147659-2.3577548l.1790122-.0071146h11.00928673l-12.82729292-13.2436894c-.89435811-.9239429-.89435811-2.4209478 0-3.3443436.84728-.8747895 2.193679-.920831 3.0934978-.1381247z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.2246517 8.3616127c-2.2519007 0-4.0773889-1.8717979-4.0773889-4.1807993s1.8254882-4.1808134 4.0773889-4.1808134c2.2519708 0 4.0774591 1.871812 4.0774591 4.1808134s-1.8254883 4.1807993-4.0774591 4.1807993z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconWhite);
export default __webpack_public_path__ + "static/media/logo_icon_white.5f9706869e3fc9cd29b5415259a372a9.svg";
export { ForwardRef as ReactComponent };